// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Yi1d","header":"ReportDetails_header__5gxN2","title":"ReportDetails_title__1Ggmo","left":"ReportDetails_left__3YHXP"};